export default "__VITE_ASSET__5c564a4a__"